export default __webpack_public_path__ + "static/media/SENAIT_FR_SEQ17.26bca76b.mp3";